module.exports = __webpack_public_path__ + "static/media/preview_escargable_3.58ed7366.png";